import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, TextField } from "@mui/material";

export const LineaSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    request
      .get("EmbudoVentas/GetLineaDDL")
      .then((result) => {
        // Agregar la opción de "Consolidado" con id 0
        const lineasOptions = [
          { value: 0, label: "Consolidado" },
          ...result.map((linea) => ({
            value: linea.idlinea,
            label: linea.linea,
          })),
        ];
        setState(lineasOptions);
      })
      .catch((error) => {
        console.error("Error obteniendo lineas:", error);
      });
  }, []);

  return (
    <select className="select-linea" name={name} value={value} onChange={onChange}>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};
